module.exports = __WEBPACK_EXTERNAL_MODULE_273__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display3D/textures/Texture","root":["openfl","display3D","textures","Texture"],"commonjs":"openfl/display3D/textures/Texture","commonjs2":"openfl/display3D/textures/Texture"}
// module id = 273
// module chunks = 0